import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=40f92932&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f92932')) {
      api.createRecord('40f92932', component.options)
    } else {
      api.reload('40f92932', component.options)
    }
    module.hot.accept("./BaseInputRadio.vue?vue&type=template&id=40f92932&", function () {
      api.rerender('40f92932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseInputRadio.vue"
export default component.exports